import React from 'react'
import { formatMoney } from '../lib/util'
import { COLORS } from '../pages/theme';
import { Link } from 'react-router-dom';
const queryString = require('query-string');

export const CustomStats=({content,label,title,titleStyle,contentStyle,labelStyle})=>{
    return <div style={{
        display:'flex',
        flexDirection:'column',
    }}>
        <div className='stat-subtitle' style={{
            ...labelStyle
        }}>{label}</div>
        {content}
        {title&&<div title={title} className='heading-1' style={{
            ...titleStyle
        }}>{title}
        </div>}
    </div>
}


export const CustomStatsSmall=({content,label,title,style,titleStyle,labelStyle,extra})=>{
    return <div style={{
        display:'flex',
        flexDirection:'column',
        ...style
    }}>
        <div className='stat-subtitle' style={{
            ...labelStyle
        }}>{label}</div>
        {content}
        {title&&<div title={title}  className='heading-2' style={{
            ...titleStyle
        }}>{title}
        </div>}
        {extra}
    </div>
}

export const CountAmountStatsLarge=({containerStyle,label,count,amount,score})=>{
    return <div style={{
        display:'flex',
        flexDirection:'column',
        ...containerStyle
    }}>
        <span className='heading-4 ' style={{
            color:COLORS.secondary
        }}>{label}</span>
        <span className='heading-large'>{count}</span>
        <span className='sub-heading-1' style={{
            color:COLORS.secondary
        }}>{formatMoney(amount)}</span>

    </div>
}


export const CountAmountStatsSmall=({
    containerStyle,label,count=0,amount,score,
    count_link,count_link_params,countStyles
})=>{
    return <div style={{
        display:'flex',
        flexDirection:'column',
        ...containerStyle
    }}>
        <span className='heading-4 ' style={{
            color:COLORS.secondary
        }}>{label}</span>
        <span className='sub-heading-large'>{score}</span>
        {count_link?<Link className='sub-heading-1' to={{
            pathname:count_link,
            search:queryString.stringify({
                    // date:"2018-12-12"
                    ...count_link_params
                })
        }}>{count}
        </Link>:
        <span className='sub-heading-1' style={{
            ...countStyles
        }}>{count}</span>}
        <span className='sub-heading-2' style={{
            color:COLORS.secondary
        }}>{formatMoney(amount)}</span>

    </div>
}